// extracted by mini-css-extract-plugin
export default {"Footer_main":"footer_Footer_main__w7HU2","supply_footer":"footer_supply_footer__7ylJI"};